import { Store } from "pullstate";

export const appStore = new Store({
  city: "",
  locations: {},
});
